import { Button } from '@statsbomb/kitbag-components';
import { useVideoCurrentTime } from '@statsbomb/video-client-js';
import { useAtomValue } from 'jotai';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from 'styled-components';
import { currentPlaybackTimeAtom } from '../../../atoms/playback/playbackStatus';
import {
  microsecondsToSeconds,
  microsecondsToTimeStamp,
  secondsToTimeStamp,
} from '../../../utils/time';
import MetadataSelections from '../../MetadataSelections';

const TimestampContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-around;
`;

export function From({
  buttonTitle,
  compact,
  disabled,
  periodStart,
  setPeriodStart,
  size,
}) {
  const intl = useIntl();

  const deprecatedPlayerCurrentTime = useAtomValue(currentPlaybackTimeAtom);
  const vilPlayerCurrentTime = useVideoCurrentTime();
  const currentPlaybackTime =
    vilPlayerCurrentTime ?? deprecatedPlayerCurrentTime;

  const handleUseCurrentAsKickoff = () => {
    setPeriodStart(
      microsecondsToTimeStamp(currentPlaybackTime, { includeDecimals: true }),
    );
  };

  const time = secondsToTimeStamp(microsecondsToSeconds(currentPlaybackTime));
  const currentPlaybackTimeDisplay = compact
    ? time
    : intl.formatMessage(
        { defaultMessage: 'Use {time}', id: '94f09' },
        {
          time,
        },
      );

  return (
    <TimestampContainer>
      <MetadataSelections.Timestamp
        disabled={disabled}
        label={intl.formatMessage({
          defaultMessage: 'Period Start',
          id: '3d83f',
        })}
        labelPosition="top"
        setTimestamp={setPeriodStart}
        size={size}
        timestamp={periodStart}
      />
      {!disabled && (
        <Button
          isDisabled={disabled}
          onClick={handleUseCurrentAsKickoff}
          size={size !== 'tiny' ? size : 'small'}
          title={intl.formatMessage(
            { defaultMessage: 'Kickoff {time}', id: '25f96' },
            {
              time,
            },
          )}
          variant="secondary"
        >
          {buttonTitle || currentPlaybackTimeDisplay}
        </Button>
      )}
    </TimestampContainer>
  );
}
From.propTypes = {
  buttonTitle: PropTypes.string,
  compact: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
  periodStart: PropTypes.number.isRequired,
  setPeriodStart: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
};
From.defaultProps = {
  buttonTitle: undefined,
  compact: false,
};

export default { From };
